<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs-6 xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="shop.code"
                  type="text"
                  :rules="rules.codeRules"
                >
                </v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="shop.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="city"
                  label="City"
                  v-model="shop.city"
                  type="text"
                  :rules="rules.cityRuels"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="township"
                  label="Township"
                  v-model="shop.township"
                  type="text"
                  :rules="rules.townshipRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="phoneNo"
                  label="Phone No"
                  v-model="shop.phoneNo"
                  type="text"
                  :rules="rules.phoneNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  :items="warehouseList"
                  v-model="shop.warehouseId"
                  label="Choose Warehouse"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="address"
                  label="Address"
                  v-model="shop.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-textarea>
              </v-flex>
              <v-flex sm12 v-if="shop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shop.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="shop.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="shop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shop.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="shop.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-switch label="B2B" :value="b2bFlag" v-model="b2bFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { shopService } from "../../services/shop-service";
import { Shop } from "../../models/model";
import { ShopFormRules } from "../../helpers/validation-rules";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";

export default {
  name: "ShopDetail",
  components: {},
  data: () => ({
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Shop",
        disabled: false,
        to: "shops",
      },
      {
        text: "Shop Detail",
        disabled: true,
      },
    ],
    shop: new Shop(),
    oldShop: new Shop(),
    rules: new ShopFormRules(),
    responseError: "",
    createdDate: "",
    updatedDate: "",
    warehouseList: [],
    b2bFlag: false,
  }),
  created() {
    this.getActiveWarehouse();

    const id = this.$route.params.id;
    if (id == "new") {
      //new shop
    } else {
      this.getShopDetail(id);
    }
  },
  methods: {
    getActiveWarehouse() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopDetail(id) {
      shopService
        .getShopById(id)
        .then((res) => {
          this.shop = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.shop.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.shop.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.b2bFlag = this.shop.isB2B;

          //deep copy
          this.oldShop = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.shop.isB2B = this.b2bFlag ? true : false;
          shopService
            .saveShop(this.shop)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.shop.id) {
        this.shop = new Shop();
        this.b2bFlag = false;
      } else {
        this.shop = Object.assign({}, this.oldShop);
        this.b2bFlag = this.shop.isB2B;
      }
    },
    goBack() {
      this.$router.push("/shops");
    },
  },
};
</script>
